import React from 'react';
import { Text } from 'dig-components/typography';
import styles from './winklink.scss';
import { UIIcon } from 'dig-components/icons';
import { AccessoryBadge } from 'dig-components/badges';
import { UpgradeLine } from 'dig-components/icons/src';

type WinkLinkProps = {
  title: string,
  showUpgrade: boolean,
  linkUrl: string,
  currentVariation: string,
  onClick: () => React.MouseEventHandler<HTMLAnchorElement>,
  isActive: boolean,
}

const WinkLink = (props: WinkLinkProps) => {

  const linkAppearance = (currentVariation: string, showUpgrade: boolean) => {
    if (currentVariation === 'V1') {
      return <div className={styles.iconText}>
        <div className={styles.icon} hidden={!showUpgrade}>
          <UIIcon src={UpgradeLine} />
        </div>
        <Text className={props.isActive ? styles.activeTitle : styles.title}> {props.title} </Text>
      </div>;
    } else if (currentVariation === 'V2') {
      return <div className={styles.badgeText}>
        <Text className={props.isActive ? styles.activeTitle : styles.title}> {props.title} </Text>
        <div className={styles.badge} hidden={!showUpgrade}>
          <AccessoryBadge>Upgrade</AccessoryBadge>
        </div>
      </div>;
    } else {
      return <Text className={props.isActive ? styles.activeTitle : styles.title}>
        {props.title}
      </Text>;
    }
  };

  return (
    <div>
      <a className={styles.linkContainer} href={props.linkUrl} onClick={props.onClick}>
        { linkAppearance(props.currentVariation, props.showUpgrade) }
      </a>
    </div>
  );
};

export default WinkLink;
